"use client";

import { useMemo, useState } from "react";
import Navbar from "../../components/account/Navbar";
import SocialSidebar from "../../components/social/layout/SocialSidebar";
import ChannelList from "../../components/channels/ChannelList";
import { useAuth } from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import "../social/SocialStyling.css";

const ChannelListPage = () => {
  const { 
    user, 
    userType, 
    getDisplayName, 
    getProfileImageUrl, 
    getUserType 
  } = useAuth();
  const { t, i18n } = useTranslation();

  // Format currentUser data like SocialFeed does
  const currentUser = useMemo(() => {
    return user
      ? {
          id: user.id || user.user_id,
          name: getDisplayName(),
          username: user.username || `@${getDisplayName().replace(/\s+/g, "").toLowerCase()}`,
          profile_image_url: user.profile_image_url || user.profile_image || user.avatar || user.image || getProfileImageUrl() || "/icons/person.png",
          avatar: user.profile_image_url || user.profile_image || user.avatar || user.image || getProfileImageUrl() || "/icons/person.png",
          role: getUserType()?.replace(/\b\w/g, (l) => l.toUpperCase()) || "Pet Guardian",
          sub_type: user.sub_type || user.subType,
          sub_type_display_name: user.sub_type_display_name || user.subTypeDisplayName,
          stats: {
            posts: user.stats?.posts || user.posts_count || 0,
            friends: user.stats?.friends ?? user.friends_count ?? 0,
            following: user.following_count || 0,
            followers: user.followers_count || 0,
          },
          friends_count: user.friends_count ?? user.stats?.friends ?? 0,
          following_count: user.following_count || 0,
          followers_count: user.followers_count || 0,
          average_rating: user.average_rating ?? user.averageRating ?? 0,
          ratings_count: user.ratings_count ?? user.ratingsCount ?? 0,
          rating_label: user.rating_label ?? user.ratingLabel ?? null,
        }
      : {
          id: 1,
          name: "Loading User",
          username: "@loading",
          profile_image_url: "/icons/person.png",
          avatar: "/icons/person.png",
          role: "Pet Guardian",
          stats: {
            posts: 0,
            following: 0,
            followers: 0,
          },
          following_count: 0,
          followers_count: 0,
          average_rating: 0,
          ratings_count: 0,
          rating_label: null,
        };
  }, [user, getDisplayName, getProfileImageUrl, getUserType]);
  return (
    <div className="social-page">
      <Navbar />
      <div className="social-page-container channel-page">
        <SocialSidebar currentUser={currentUser} userType={userType} />
        <div className="social-page-main">
          <ChannelList />
        </div>
      </div>
    </div>
  );
};

export default ChannelListPage;

